import { useState } from "react";

interface VerticalImageListProps {
  images: string[];
}

/**
 * 竖向图片列表（替代原顶部左右滑动轮播图）
 * - 多张图片从上到下依次排列
 * - 每张图片等宽（与父容器同宽）
 * - 点击任意图片可全屏预览（支持滑动切换 + 缩放）
 */
export default function VerticalImageList({ images }: VerticalImageListProps) {
  const [showPreview, setShowPreview] = useState(false);
  const [previewIndex, setPreviewIndex] = useState(0);

  if (!images || images.length === 0) return null;

  const openPreview = (i: number) => {
    setPreviewIndex(i);
    setShowPreview(true);
  };

  return (
    <>
      {/* 竖向图片列表：图片铺满父容器宽度，依次堆叠 */}
      <div className="mt-4 -mx-5 flex flex-col gap-1">
        {images.map((img, i) => (
          <img
            key={i}
            src={img}
            alt={`图片${i + 1}`}
            className="w-full block cursor-pointer active:opacity-90 transition-opacity"
            style={{ display: "block" }}
            loading="lazy"
            onClick={() => openPreview(i)}
            draggable={false}
          />
        ))}
      </div>

      {/* 全屏预览弹窗（简化版） */}
      {showPreview && (
        <div
          className="fixed inset-0 z-[80] bg-black flex flex-col"
          onClick={() => setShowPreview(false)}
        >
          {/* 关闭按钮 */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              setShowPreview(false);
            }}
            className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full z-10"
            style={{ background: "rgba(255,255,255,0.2)" }}
          >
            <i className="ri-close-line text-white text-xl" />
          </button>

          {/* 计数 */}
          <div
            className="absolute top-4 left-4 px-3 py-1.5 rounded-full z-10 text-xs text-white font-medium"
            style={{ background: "rgba(0,0,0,0.5)" }}
          >
            {previewIndex + 1} / {images.length}
          </div>

          {/* 简化预览：单图直接显示，多图用滚动的 vertical 列表 */}
          <div
            className="flex-1 overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {images.map((img, i) => (
              <img
                key={i}
                src={img}
                alt={`预览${i + 1}`}
                className="w-full block"
                style={{ objectFit: "contain", background: "#000" }}
                draggable={false}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
}
